import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'config/i18n';
import Container from '@material-ui/core/Container';
import EarningsAndPayouts from 'components/ownerPages/earningsAndPayouts';

import serverLogger from 'utils/serverLogger';

const OwnerPayouts = () => {
  serverLogger.debug('---[Trace] Inside Owner payouts page');

  return (
    <Container>
      <EarningsAndPayouts />
    </Container>
  );
};

OwnerPayouts.getInitialProps = async () => {
  serverLogger.debug('---[Trace] Inside Owner VRs getInitialProps');

  return {
    namespacesRequired: ['fe_earnings_and_payouts_page', 'fe_pagination'],
    requireAuth: true,
  };
};

OwnerPayouts.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation(['fe_earnings_and_payouts_page'])(OwnerPayouts);
